import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Customer, CustomerAccountItem } from '@inyova/models';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as ProfileActions from '../../profile.actions';
import * as fromProfile from '../../profile.reducers';

@Component({
  selector: 'app-profile-i4k-names',
  templateUrl: './profile-i4k-names.component.html',
  styleUrls: ['./profile-i4k-names.component.scss'],
  standalone: false
})
export class ProfileI4kNamesComponent implements OnInit, OnDestroy {
  nameForm: FormGroup;
  selectedKidAccount: CustomerAccountItem | null = null;

  loading$: Observable<boolean>;
  showI4KNameList$: Observable<boolean>;

  @Input() customer: Partial<Customer>;

  get firstNameControl(): AbstractControl | null {
    return this.nameForm.get('firstName');
  }

  get kidAccounts(): CustomerAccountItem[] {
    return this.customer.accounts.filter((customerAccount: CustomerAccountItem) => customerAccount.kind === 'kid');
  }

  constructor(
    private fb: FormBuilder,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.loading$ = this.store.select(fromProfile.selectLoading);
    this.showI4KNameList$ = this.store.select(fromProfile.selectShowI4KNameList);
    this.nameForm = this.initializeForm();
  }

  ngOnDestroy() {
    this.store.dispatch(ProfileActions.toggleProfileI4KList({ showI4KNameList: true }));
  }

  initializeForm(): FormGroup {
    return this.fb.group({
      firstName: ['', [Validators.required]]
    });
  }

  onEditName(kidAccount: CustomerAccountItem) {
    this.selectedKidAccount = kidAccount;

    this.firstNameControl.setValue(kidAccount.owner_name);
    this.nameForm.updateValueAndValidity();

    this.store.dispatch(ProfileActions.toggleProfileI4KList({ showI4KNameList: false }));
  }

  onSubmit() {
    if (this.nameForm.invalid) {
      return;
    }
    // skip save if the name is the same
    const ownerName = `${(this.firstNameControl.value as string).trim()}`;
    if (ownerName === this.selectedKidAccount.owner_name) {
      this.onCancel();
      return;
    }
    this.store.dispatch(ProfileActions.updateProfileOwnerName({ accountId: this.selectedKidAccount.id, ownerName }));
  }

  onCancel() {
    this.selectedKidAccount = null;
    this.store.dispatch(ProfileActions.toggleProfileI4KList({ showI4KNameList: true }));
  }
}
